export default [
  { text: 'Actions', value: 'actions', sortable: false, width: '80px',  },
  { text: '', value: 'id', width: '55px' },
  { text: 'Name', value: 'name' , width: '130px'},
  // { text: 'Address', value: 'address' },
  { text: 'Client', value: 'client' , width: '100px'},
  { text: 'Small Models', value: 'smallModelsLimitUsed', width: '200px' },
  { text: 'Scans Upload', value: 'scanUploadLimitUsed', width: '200px' },
  { text: 'Scans Download', value: 'scanDownloadLimitUsed', width: '200px' },
  { text: 'Created By', value: 'createdBy' },
];
